import React from "react";
import { Link } from "react-router-dom";
import { FaGithub, FaLinkedin } from "react-icons/fa";
import "../assets/css/nav.css";
import "../assets/css/font.css";
import { useLanguage } from "./LanguageContext";
import { useActiveSection } from "./ActiveSectionContext";

const SECTIONS = ["about", "experience", "projects", "contact"];

function NavLinks(props) {
  const { t, lang } = useLanguage();
  const { activeId } = useActiveSection();

  return (
    <nav className="header-nav">
      {SECTIONS.map((id) => (
        <Link
          key={id}
          onClick={props.onClick}
          to={`/${lang}#${id}`}
          className={activeId === id ? "active" : undefined}
          aria-current={activeId === id ? "true" : undefined}
        >
          {t.nav[id]}
        </Link>
      ))}
      <div className="header-nav-socials">
        <a
          href="https://github.com/viniciuspx"
          target="_blank"
          rel="noreferrer"
          aria-label="GitHub"
          onClick={props.onClick}
        >
          <FaGithub />
        </a>
        <a
          href="https://www.linkedin.com/in/viniciuspx/"
          target="_blank"
          rel="noreferrer"
          aria-label="LinkedIn"
          onClick={props.onClick}
        >
          <FaLinkedin />
        </a>
        <Link
          onClick={props.onClick}
          to={`/${lang}/resume`}
          className="button button-secondary header-resume"
        >
          {t.nav.resume}
        </Link>
      </div>
    </nav>
  );
}

export default NavLinks;
